import { useState, useEffect } from "react";
import { getMatches, getIntervalloRefresh } from "../api/api.js";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button, Modal, Form } from "react-bootstrap";

export default function MatchArea() {
  
  const [UPDATE_INTERVAL, setUpdateInterval] = useState(10); // default 10
  const [aree, setAree] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedCategoria, setSelectedCategoria] = useState("");
  const [dimensions, setDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [countdown, setCountdown] = useState(UPDATE_INTERVAL);
  const token = localStorage.getItem("access_token");
  let role = null;
  if (token) {
    const payload = JSON.parse(atob(token.split('.')[1]));
    role = payload.role;
  }

  const navigate = useNavigate();
  const colors = ["#007bff", "#28a745", "#ffc107", "#dc3545", "#6f42c1", "#20c997"];

  const fetchData = async () => {
    try {
      const res = await getMatches();
      if (!res.ok) throw new Error(res.error || "Errore nel fetch");
      setAree(res.data.aree || []);
      setCategorie(res.data.categorie || []);
      setCountdown(UPDATE_INTERVAL); // reset countdown
    } catch (err) {
      console.error(err);
    }
  };

  const fetchInterval = async () => {
    try {
      const res = await getIntervalloRefresh();
      if (res.ok && res.data && res.data.value) {
        setUpdateInterval(res.data.value);
        setCountdown(res.data.value);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
    fetchInterval();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Countdown e refresh automatico
  useEffect(() => {
    if (!UPDATE_INTERVAL) return; // evita timer con 0 o undefined
    setCountdown(UPDATE_INTERVAL);

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          fetchData();
          return UPDATE_INTERVAL;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UPDATE_INTERVAL]);


  useEffect(() => {
    const handleResize = () => setDimensions({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openCategoryModal = (areaId) => {
    setSelectedArea(areaId);
    setSelectedCategoria("");
    setShowModal(true);
  };

  const openCurrent = (areaId, categoria) => {
    if(categoria == "null") return;
    navigate(`/match/${areaId}/${encodeURIComponent(categoria)}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedArea || !selectedCategoria) return;
    setShowModal(false);
    navigate(`/match/${selectedArea}/${encodeURIComponent(selectedCategoria)}`);
  };

  const colsPerRow = dimensions.width > 600 ? 2 : 1;

  const renderAbbinamenti = (abbinamenti) => (
    abbinamenti?.length > 0 ? abbinamenti.map((ab, i) => (
      <div key={i} className="d-flex justify-content-between mb-1" style={{ fontSize: "0.95rem", gap: "0.15rem" }}>
        <div className="text-center">
          <div className="fw-bold" style={{ fontSize: "1rem" }}>{ab.palestra_r}</div>
          <div style={{ fontSize: "0.95rem" }}>{ab.atleta_r}</div>
        </div>
        <div style={{ color: "red", fontWeight: "bold"}}>vs</div>
        <div className="text-center">
          <div className="fw-bold" style={{ fontSize: "1rem" }}>{ab.palestra_b}</div>
          <div style={{ fontSize: "0.95rem" }}>{ab.atleta_b}</div>
        </div>
      </div>
    )) : <div className="text-center text-muted small">—</div>
  );

  return (
    <Container fluid className="px-2 py-2">
      <h2 className="text-center mb-3">Aree di Gara</h2>

      <p className="text-center text-danger fw-bold small mb-3">
        Aggiornamento automatico in {countdown}s
      </p>

      <Row className="g-1 justify-content-center">
        {aree.map((area, index) => {
          const color = colors[index % colors.length];
          const hasAbbinamenti = (area.abbinamento_attuale?.length > 0 || area.abbinamento_successivo?.length > 0);

          return (
            <Col key={area.id} xs={12} md={12 / colsPerRow} className="d-flex">
              <Card
                className="flex-fill d-flex flex-column justify-content-between"
                style={{
                  fontSize: "0.85rem",
                  borderTop: `4px solid ${color}`,
                  padding: "0.25rem",
                  minHeight: hasAbbinamenti ? "150px" : "100px",
                }}
              >
                <div className="text-center mb-1">
                  <strong>{area.nome}</strong>
                  <br />
                  <small className="mb-0.5">{area.categoria || "—"}</small>
                </div>

                <Row className="g-1 flex-fill">
                  <Col xs={6} className="d-flex flex-column" style={{ borderRight: "3px solid #333", padding: "0 1rem" }}>
                    <div className="text-center text-warning fw-bold mb-1" style={{ fontSize: "0.85rem" }}>Attuale</div>
                    <div className="flex-fill d-flex flex-column justify-content-start" style={{ fontSize: "0.95rem", gap: "0.15rem" }}>
                      {renderAbbinamenti(area.abbinamento_attuale)}
                    </div>
                  </Col>
                  <Col xs={6} className="d-flex flex-column" style={{ padding: "0 1rem" }}>
                    <div className="text-center fw-bold mb-1" style={{ fontSize: "0.85rem" }}>Successivo</div>
                    <div className="flex-fill d-flex flex-column justify-content-start" style={{ fontSize: "0.95rem", gap: "0.15rem" }}>
                      {renderAbbinamenti(area.abbinamento_successivo)}
                    </div>
                  </Col>
                </Row>

               {role !== "coach" && role && (
                <div className="text-center mt-1">
                  <Button
                    size="sm"
                    variant="outline-primary"
                    onClick={() => openCurrent(area.id, area.categoria)}
                  >
                    Apri Categoria Corrente
                  </Button>

                  <Button
                    size="sm"
                    variant="outline-primary"
                    className="ms-2"
                    onClick={() => openCategoryModal(area.id)}
                  >
                    Gestione
                  </Button>
                </div>
                )}
              </Card>
            </Col>
          );
        })}

        <Col xs={12} md={12 / colsPerRow} className="d-flex">
          <Card
            className="flex-fill d-flex flex-column justify-content-center align-items-center"
            style={{
              minHeight: "120px",
              borderTop: "4px solid #000",
              padding: "0.25rem",
            }}
          >
            <img src="/qr-code.png" alt="Lista Match Dettagliata" style={{ maxWidth: "90%", maxHeight: "90%" }} />
            <div className="mt-1 text-center fw-bold" style={{ fontSize: "0.85rem" }}>Lista Match Dettagliata</div>
          </Card>
        </Col>
      </Row>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Seleziona Categoria</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Categoria</Form.Label>
              <Form.Select
                value={selectedCategoria}
                onChange={(e) => setSelectedCategoria(e.target.value)}
                required
              >
                <option value="" disabled>Seleziona una categoria</option>
                {categorie.map((c, i) => <option key={i} value={c}>{c}</option>)}
              </Form.Select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">OK</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
}
